module.exports = __webpack_public_path__ + "static/chart-2_animation-3093fa6cf0aa1846e9835c335540f92a.mp4";